import { render, staticRenderFns } from "./ProjectsLists.vue?vue&type=template&id=876da8fa&scoped=true"
import script from "./ProjectsLists.vue?vue&type=script&lang=ts"
export * from "./ProjectsLists.vue?vue&type=script&lang=ts"
import style0 from "./ProjectsLists.vue?vue&type=style&index=0&id=876da8fa&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "876da8fa",
  null
  
)

export default component.exports